import React from 'react'
import { Route, IndexRoute } from 'react-router'

import DisplayConfigs from '../components/display-configs/list'
import EditDisplayConfig from '../components/display-configs/edit'
import CreateDisplayConfig from '../components/display-configs/create'

import Groups from '../components/groups/list'
import EditGroup from '../components/groups/edit'
import CreateGroup from '../components/groups/create'

import Homeworks from '../components/homeworks/list'
import EditHomework from '../components/homeworks/edit'
import CreateHomework from '../components/homeworks/create'
import CopyHomework from '../components/homeworks/copy'

import HomeworkTasks from '../components/homework-tasks/list'
import EditHomeworkTask from '../components/homework-tasks/edit'
import CreateHomeworkTask from '../components/homework-tasks/create'

import EditHomeworkSection from '../components/homework-sections/edit'

import Members from '../components/members/list'
import EditMember from '../components/members/edit'
import CreateMember from '../components/members/create'

import Pages from '../components/pages/list'
import EditPage from '../components/pages/edit'
import CreatePage from '../components/pages/create'

import PrivateCoachings from '../components/private-coachings/list'
import EditPrivateCoaching from '../components/private-coachings/edit'
import CreatePrivateCoaching from '../components/private-coachings/create'

import Programs from '../components/programs/list'
import EditProgram from '../components/programs/edit'
import CreateProgram from '../components/programs/create'

import ProgramQuestions from '../components/program-questions/list'
import EditProgramQuestion from '../components/program-questions/edit'
import CreateProgramQuestion from '../components/program-questions/create'

import ProgramTimers from '../components/program-timers/list'
import EditProgramTimer from '../components/program-timers/edit'
import CreateProgramTimer from '../components/program-timers/create'

import Questions from '../components/questions/list'
import EditQuestion from '../components/questions/edit'
import CreateQuestion from '../components/questions/create'

import Resources from '../components/resources/list'
import EditResource from '../components/resources/edit'
import CreateResource from '../components/resources/create'

import ResourceCategories from '../components/resource-categories/list'
import EditResourceCategory from '../components/resource-categories/edit'
import CreateResourceCategory from '../components/resource-categories/create'

import Sessions from '../components/sessions/list'
import EditSession from '../components/sessions/edit'
import CreateSession from '../components/sessions/create'
import CopySession from '../components/sessions/copy'

import SessionNotifications from '../components/session-notifications/list'
import EditSessionNotification from '../components/session-notifications/edit'
import CreateSessionNotification from '../components/session-notifications/create'

import SessionRestrictedPages from '../components/session-restricted-pages/list'
import EditSessionRestrictedPage from '../components/session-restricted-pages/edit'
import CreateSessionRestrictedPage from '../components/session-restricted-pages/create'
import ImportSessionRestrictedPage from '../components/session-restricted-pages/import'

import TimerTypes from '../components/timer-types/list'
import EditTimerType from '../components/timer-types/edit'
import CreateTimerType from '../components/timer-types/create'

import Topics from '../components/topics/list'
import EditTopic from '../components/topics/edit'
import CreateTopic from '../components/topics/create'
import CopyTopic from '../components/topics/copy'

import CheckinReminders from '../components/checkin-reminders'
import FSPGroupSort from '../components/fsp-group-sort'

import CommentBots from '../components/comment-bots/list'
import CreateCommentBot from '../components/comment-bots/create'
import EditCommentBot from '../components/comment-bots/edit'
import CopyCommentBot from '../components/comment-bots/copy'

import CommentBotRuns from '../components/comment-bots/comment-bot-runs/list'
import ShowCommentBotRun from '../components/comment-bots/comment-bot-runs/show'

const WriteNowRoutes = (
  <Route path='write-now'>
    <Route path='display_configs'>
      <IndexRoute component={DisplayConfigs} />
      <Route path='create' component={CreateDisplayConfig} />
      <Route path=':displayConfigId/edit' component={EditDisplayConfig} />
    </Route>

    <Route path='groups'>
      <IndexRoute component={Groups} />
      <Route path=':groupId/edit' component={EditGroup} />
      <Route path='create' component={CreateGroup} />
    </Route>

    <Route path='homework'>
      <IndexRoute component={Homeworks} />
      <Route path='create' component={CreateHomework} />
      <Route path=':homeworkId/edit' component={EditHomework} />
      <Route path=':homeworkId/copy' component={CopyHomework} />
      <Route path=':homeworkId/tasks'>
        <IndexRoute component={HomeworkTasks} />
        <Route path='create' component={CreateHomeworkTask} />
        <Route path=':homeworkTaskId/edit' component={EditHomeworkTask} />
      </Route>
      <Route path=':homeworkId/sections'>
        <Route path=':homeworkSectionId/edit' component={EditHomeworkSection} />
      </Route>
    </Route>

    <Route path='members'>
      <IndexRoute component={Members} />
      <Route path=':memberId/edit' component={EditMember} />
      <Route path='create' component={CreateMember} />
    </Route>

    <Route path='sessions'>
      <IndexRoute component={Sessions} />
      <Route path=':sessionId/edit' component={EditSession} />
      <Route path=':sessionId/copy' component={CopySession} />
      <Route path='create' component={CreateSession} />
    </Route>

    <Route path='session_notifications'>
      <IndexRoute component={SessionNotifications} />
      <Route
        path=':sessionNotificationId/edit'
        component={EditSessionNotification}
      />
      <Route path='create' component={CreateSessionNotification} />
    </Route>

    <Route path='session_restricted_pages'>
      <IndexRoute component={SessionRestrictedPages} />
      <Route
        path=':sessionRestrictedPageId/edit'
        component={EditSessionRestrictedPage}
      />
      <Route path='create' component={CreateSessionRestrictedPage} />
      <Route path='import' component={ImportSessionRestrictedPage} />
    </Route>

    <Route path='pages'>
      <IndexRoute component={Pages} />
      <Route path='create' component={CreatePage} />
      <Route path=':pageId/edit' component={EditPage} />
    </Route>

    <Route path='private_coachings'>
      <IndexRoute component={PrivateCoachings} />
      <Route path='create' component={CreatePrivateCoaching} />
      <Route path=':privateCoachingId/edit' component={EditPrivateCoaching} />
    </Route>

    <Route path='programs'>
      <IndexRoute component={Programs} />
      <Route path='create' component={CreateProgram} />
      <Route path=':programId/edit' component={EditProgram} />
    </Route>

    <Route path='program_questions'>
      <IndexRoute component={ProgramQuestions} />
      <Route path='create' component={CreateProgramQuestion} />
      <Route path=':programQuestionId/edit' component={EditProgramQuestion} />
    </Route>

    <Route path='program_timers'>
      <IndexRoute component={ProgramTimers} />
      <Route path='create' component={CreateProgramTimer} />
      <Route path=':programTimerTypeId/edit' component={EditProgramTimer} />
    </Route>

    <Route path='questions'>
      <IndexRoute component={Questions} />
      <Route path='create' component={CreateQuestion} />
      <Route path=':questionId/edit' component={EditQuestion} />
    </Route>

    <Route path='comment-bots'>
      <IndexRoute component={CommentBots} />
      <Route path='create' component={CreateCommentBot} />
      <Route path=':commentBotId/edit' component={EditCommentBot} />
      <Route path=':commentBotId/copy' component={CopyCommentBot} />

      <Route path='history'>
        <IndexRoute component={CommentBotRuns} />
        <Route path=':commentBotRunId' component={ShowCommentBotRun} />
      </Route>
    </Route>

    <Route path='reminders'>
      <IndexRoute component={CheckinReminders} />
    </Route>

    <Route path='resources'>
      <IndexRoute component={Resources} />
      <Route path='create' component={CreateResource} />
      <Route path=':resourceId/edit' component={EditResource} />
    </Route>

    <Route path='resource_categories'>
      <IndexRoute component={ResourceCategories} />
      <Route path='create' component={CreateResourceCategory} />
      <Route path=':resourceCategoryId/edit' component={EditResourceCategory} />
    </Route>

    <Route path='timer_types'>
      <IndexRoute component={TimerTypes} />
      <Route path='create' component={CreateTimerType} />
      <Route path=':timerTypeId/edit' component={EditTimerType} />
    </Route>

    <Route path='topics'>
      <IndexRoute component={Topics} />
      <Route path='create' component={CreateTopic} />
      <Route path=':topicId/edit' component={EditTopic} />
      <Route path=':topicId/copy' component={CopyTopic} />
    </Route>

    <Route path='fsp-group-sorting'>
      <IndexRoute component={FSPGroupSort} />
    </Route>
  </Route>
)

export default WriteNowRoutes
